import { render, staticRenderFns } from "./Paiements.vue?vue&type=template&id=5fcf3bbe&"
import script from "./Paiements.vue?vue&type=script&lang=js&"
export * from "./Paiements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports